import React, { 
    useState, 
    useRef, 
    useEffect, 
    forwardRef, 
    useImperativeHandle 
} from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Tagify from "@yaireo/tagify";


import ValidationMessage from '../../../../../../../../../component/common/ValidationMessage';
import AlertMessage from '../../../../../../../../../component/common/AlertMessage';

const FinalSetupForm = forwardRef((props, ref) => {
    const {
        othersFormUpdateState,
        formValidateError,
        formActionType,
        formData
    } = props;
    // ------- General Intent value ------- //
    const generalIntentObj = [
        {label: 'Greeting', value: 'Greeting'},
        {label: 'Thankful', value:'Thankful'},
        {label: 'Pause', value:'Pause'},
        {label: 'Redirect', value:'Redirect'},
        {label: 'Affirm', value:'Affirm'},
        {label: 'Denied', value:'Denied'},
    ];
    const [generalIntentState, setGeneralIntentState] = useState(generalIntentObj);
    const previousGeneralIntentData = formData['step5'].final_form_setup;
    useEffect(() => {
        if(previousGeneralIntentData.length > 0){
            const selectedValues = previousGeneralIntentData.map(item => item.general_intent.value);
            const filteredIntentObj = generalIntentObj.filter(
                item => !selectedValues.includes(item.value)
            );
            setGeneralIntentState(filteredIntentObj)
        }
    },[previousGeneralIntentData]);
    // ----- set tagify ----- //
    const multipleResponseRef = useRef(null);
    const tagifyRef = useRef(null);
    useEffect(() => {
        if (multipleResponseRef.current) {
            tagifyRef.current = new Tagify(multipleResponseRef.current);
        }
        return () => {
            if (tagifyRef.current) {
                tagifyRef.current.destroy();
            }
        };
    },[]);

    const [ followUpDetailsVal, setFollowUpDetailsVal ] = useState('');

    const [ othersFormError, setOthersFormError ] = useState({});
    const [ othersFormData, setOthersFormData ] = useState({ 
        add_example : '',
        general_intent : null,
        multiple_response : '',
        follow_up_details : null,
        affirm_of_deny : null,
        select_action : null,
        closing_utterance : '',
        feedback : ''
    });

    const validateField = (name, value) => {
        let error = "";
        if (name === "general_intent") {
            if (!value) {
                error = "General intent is required.";
            }
        }
        if (name === "add_example") {
            if (!value) {
                error = "Example is required.";
            }
        }
        if (name === "multiple_response") {
            if (!value) {
                error = "Multiple response is required.";
            }
        }
        return error;
    }

    const [othAffirmOfDeny, setOthAffirmOfDeny] = useState('');
    const othersInputOnChange = (selectedOption, actionMeta) => {
        if (actionMeta?.name) {
            // ------- manage select field --------- //
            const { name } = actionMeta;
            if(name === 'follow_up_details'){
                if(selectedOption){
                    setFollowUpDetailsVal(selectedOption.value)
                }
                else{
                    setFollowUpDetailsVal('')
                }
            }
            if( name === 'affirm_of_deny' ){
                if(selectedOption){
                    setOthAffirmOfDeny(selectedOption.value)
                }
            }

            setOthersFormData((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
            const fieldError = validateField(name, selectedOption);
            setOthersFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
        }
        else if(selectedOption?.target){
            const { name, value } = selectedOption.target;
            let newVal = value

            // const fieldsToValidate = ['add_example'];
            // if (fieldsToValidate.includes(name)) {
            //     newVal = specialCharacterValidate(newVal);
            // }

            // ----- manage input field -------- //
            setOthersFormData((prevData) => ({
                ...prevData,
                [name]: newVal,
            }));
            const fieldError = validateField(name, value);
            setOthersFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
        }
    }

    const othersSetupSaveOnClick = (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in othersFormData) {
            newErrors[key] = validateField(key, othersFormData[key]);
        }
        setOthersFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            props.othersFormSave(othersFormData)
            setFollowUpDetailsVal('')
        }
    }

    useImperativeHandle(ref, () => ({
        resetForm: () => {
            setOthersFormData((prevState) => ({
                ...prevState,
                add_example: "",
                general_intent : null,
                multiple_response : '',
                follow_up_details : null,
                affirm_of_deny : null,
                select_action : null,
                closing_utterance : '',
                feedback : ''
            }));
            setFollowUpDetailsVal('')
        }
    }));

    useEffect(() => {
        if( othersFormUpdateState.length > 0 ){
            if(formActionType === 'update'){
                let othersUpdateData = othersFormUpdateState[0];
                setOthersFormData((prevState) => ({
                    ...prevState,
                    add_example: othersUpdateData.add_example,
                    general_intent : othersUpdateData.general_intent,
                    follow_up_details : othersUpdateData.follow_up_details,
                    affirm_of_deny : othersUpdateData.affirm_of_deny,
                    select_action : othersUpdateData.select_action,
                    closing_utterance : othersUpdateData.closing_utterance,
                    feedback : othersUpdateData.feedback,
                }));
                othersInputOnChange(
                    othersUpdateData.follow_up_details, 
                    {action : "select-option",name : "follow_up_details"}
                );
                othersInputOnChange(
                    othersUpdateData.affirm_of_deny, 
                    {action : "select-option",name : "affirm_of_deny"}
                )
                setTimeout(() => {
                    if (multipleResponseRef.current) {
                        tagifyRef.current.removeAllTags();
                        tagifyRef.current.addTags(othersUpdateData.multiple_response);
                    }
                }, 100);
            }
            else{
                setOthersFormData({
                    add_example : '',
                    general_intent : null,
                    multiple_response : '',
                    follow_up_details : null,
                    affirm_of_deny : null,
                    select_action : null,
                    closing_utterance : '',
                    feedback : ''
                })
            }
        }
    },[othersFormUpdateState]);

    // ----------- manage action data --------- //
    const [ actionName, setActionName ] = useState([]);
    const othersFormSetupAction = formData.step2.others_form_setup;
    const pfAssAction = formData.step3.product_features_association_data;
    const serviceAction = formData.step4.service_setup;
    const serviceCombinedData = [
        ...othersFormSetupAction, 
        ...pfAssAction, 
        ...serviceAction
    ];
    useEffect(() => {
        if(serviceCombinedData.length > 0){
            const uniqueActions = [...new Map(serviceCombinedData.map(item => [item.action_name, item])).values()];
            var selectAction = uniqueActions.map(item => ({
                label: item.action_name,
                value: item.action_name
            }));
            setActionName(selectAction)
        }
    }, [othersFormSetupAction, pfAssAction, serviceAction])


    const infoPopupData = {
        'general_intent' : {
            'title' : 'General intent',
            'info' : `You can select from pre-created Actions.`,
        },
        'add_example' : {
            'title' : 'Add example',
            'info' : `Provide an example of how your customer would query about this information item. For example, "Hello?" or "Pleae give me a moment?" etc.`,
        },
        'follow_up_details' : {
            'title' : 'Follow up details',
            'info' : `Follow-up Actions automatically trigger an Agent response after fulfilling the customer query. For example, after providing product information, you may want the Agent to ask, "Would you like to place an order now?"
            Opt-in Action is when you would like the Agent to query like, "Would you like to place an order?". If the customer says Yes, you can add Sell Action as the Follow-up Action. Note that Sell Action should be pre-created to be invoked here. If you have not already created, you can come back here using Edit Agent mode and add it later.  If the customer denies with a No, you can provide some response such as, "That is fine. Let me know if I can do anything else for you."
            Use Closing Utterance for a simple closing response such as, "Glad to be of help."
            Feedback is a specific type of Follow-up Action where you can collect Ratings or some feedback. This feature is not available yet.
            Use this for providing information in an interactive mode to your customers. It can be a Product or a Service that you provide. For example, your customer may inquire about the EV you sell or a Hotel Accommodation.`,
        },
        'multiple_response' : {
            'title' : 'Multiple response',
            'info' : `If you provide multiple responses, the Agent will use round robin mode to respond, among all conversations. Note that this is not at a customer level but at a global level.`,
        },
    }

    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }

    return (
        <>
            <div className='row'>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Select General Intent
                    </label>
                    {
                        formActionType === 'insert' && 
                        <>
                            <span 
                                className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                onClick={(e) => infoOpenOnCLick('general_intent')}
                            >
                                <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                            </span>
                        </>
                    }
                   
                    <Select 
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={generalIntentState}
                        placeholder='Select an option' 
                        onChange={othersInputOnChange}
                        name="general_intent"
                        value={othersFormData.general_intent}
                    />
                    {
                        othersFormError.general_intent &&
                        <ValidationMessage className='text-danger' message ={othersFormError.general_intent}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Add Example
                    </label>
                    {
                        formActionType === 'insert' && 
                        <>
                            <span 
                                className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                onClick={(e) => infoOpenOnCLick('add_example')}
                            >
                                <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                            </span>
                        </>
                    }
                    
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter example"
                        onChange={othersInputOnChange}
                        name="add_example"
                        value={othersFormData.add_example}
                        autoFocus
                    />
                    {
                        othersFormError.add_example &&
                        <ValidationMessage className='text-danger' message ={othersFormError.add_example}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Add Multiple Response
                    </label>
                    {
                        formActionType === 'insert' && 
                        <>
                            <span 
                                className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                                onClick={(e) => infoOpenOnCLick('multiple_response')}
                            >
                                <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                            </span>
                        </>
                    }
                    
                    <span className="fw-semibold text-primary d-block fs-8 ms-2 float-end">
                        (Press Enter to add each response.)
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter response"
                        ref={multipleResponseRef}
                        onChange={othersInputOnChange}
                        name="multiple_response"
                        value={othersFormData.multiple_response}
                    />
                    {
                        othersFormError.multiple_response &&
                        <ValidationMessage className='text-danger' message = {othersFormError.multiple_response}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label">
                        Follow-up Details
                    </label>
                    {
                        formActionType === 'insert' && 
                        <>
                            <span 
                                className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                                onClick={(e) => infoOpenOnCLick('follow_up_details')}
                            >
                                <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                            </span>
                        </>
                    }
                    <Select 
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={[
                            {label: 'Opt-in',  value : 'opt_in'},
                            {label: 'Closing utterance', value:'closing_utterance'},
                            {label: 'Feedback', value:'feedback'},
                        ]}
                        placeholder='Select an option'
                        name="follow_up_details"
                        onChange={othersInputOnChange}
                        value={othersFormData.follow_up_details}
                        isClearable
                    />
                </div>
                {(followUpDetailsVal === 'opt_in' || followUpDetailsVal === 'Opt-in') && (
                    <div className="col-md-12 mb-5">
                        <label className="form-label">Affirm or Deny</label>
                        <Select 
                            className='react-select-styled react-select-solid' 
                            classNamePrefix='react-select' 
                            options={[
                                {label: 'Yes', value: 'yes'},
                                {label: 'No', value: 'no'},
                            ]}
                            placeholder='Select an option'
                            name="affirm_of_deny"
                            onChange={othersInputOnChange}
                            value={othersFormData.affirm_of_deny}
                            isClearable
                        />
                    </div>
                )}
                {
                    (followUpDetailsVal === 'opt_in' || followUpDetailsVal === 'Opt-in') && 
                    (othAffirmOfDeny === 'yes' || othAffirmOfDeny === 'Yes') && (
                        <div className='col-md-12'>
                            <label className="form-label">
                                Select Action
                            </label>
                            <Select
                                className='react-select-styled react-select-solid react-select-sm' 
                                classNamePrefix='react-select' 
                                options={actionName}
                                placeholder='Select an option' 
                                name='select_action'
                                onChange={othersInputOnChange}
                                value={othersFormData.select_action}
                                isClearable
                            />
                        </div>
                    )
                }
                {
                    (followUpDetailsVal === 'closing_utterance' || followUpDetailsVal === 'Closing utterance') && (
                        <div className="col-md-12 mb-5">
                            <label className="form-label">
                                Enter Closing Utterance
                            </label>
                            <input
                                type="text"
                                className="form-control form-control-solid"
                                placeholder="Enter closing utterance"
                                name="closing_utterance"
                                onChange={othersInputOnChange}
                                value={othersFormData.closing_utterance}
                            />
                        </div>
                    )
                }
                {
                    (followUpDetailsVal === 'feedback' || followUpDetailsVal === 'Feedback') &&(
                        <div className="col-md-12 mb-5">
                            <label className="form-label">
                                Feedback
                            </label>
                            <input
                                type="text"
                                className="form-control form-control-solid"
                                placeholder="Enter feedback"
                                name="feedback"
                                onChange={othersInputOnChange}
                                value={othersFormData.feedback}
                            />
                        </div>
                    ) 
                }
                <div className='col-md-12 text-end m-auto mt-2'>
                    {
                        formActionType === 'insert' &&
                        <div className="btn btn-dark btn-icon btn-sm" onClick={othersSetupSaveOnClick}>
                            <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                        </div>
                    }
                     {
                        formActionType === 'update' &&
                        <div className="btn btn-primary btn-sm" onClick={othersSetupSaveOnClick}>
                            Update
                        </div>
                    }
                </div>
                {
                    formValidateError?.final_form_setup &&
                    <div className="col-md-12 mt-5">
                        <AlertMessage
                            sub_title = {formValidateError?.final_form_setup}
                            type = 'danger'
                        />
                    </div>
                }
            </div>
        </>
    )
})

export default FinalSetupForm